import workshopImage from './assets/workshop.png'; 
import workShopPoster from './assets/workshop_poster.jpeg';
import warOfWestros from './assets/The-war-of-Westros.png';
import kingsDesign from './assets/The-kings-design.png';
import ironCodeRelay from './assets/The-Iron-Code-Relay.png';
import scrollsOfSevenKingdoms from './assets/Scrolls-of-the-Seven-Kingdoms.png';
import questBeyondWall from './assets/Quest-Beyond-the-Wall.png';
import drogonsHackfest from './assets/Drogons-Hackfest.png';
import defendersPitch from './assets/Defenders-Pitch.png';
import captureTheThrone from './assets/Capture-the-Throne.png';

export const events = [
  {
    path: "/Capture-the-Throne",
    name: "Capture the Throne",
    sh_desc: "Cybersecurity competition used to test computer security skills",
    description: `Capture the Flag is an interactive cybersecurity competition designed to challenge participants’ skills in various domains of computer security. These events can vary in format, ranging from individual competitions to team-based challenges, and typically include a series of tasks or puzzles that participants must solve to earn points. The ultimate goal is to "capture" virtual flags, which are usually strings of text hidden within various challenges.`,
    rules: [
      "Team Composition: Each team must consist of 3 members.",
      "Duration: The competition will last for 2.5 hours.",
      "Equipment: Laptops are required for all participants.",
      "Phone Policy: No phone usage is allowed during the competition.",
      "Identification: Participants must bring their ID cards.",
      "Development Tools: Teams should download the required development tools ahead of time.",
      "Internet Access: Bring wifi hotspots as backup, as wifi will be available but its reliability is not guaranteed.",
      "Charger Reminder: Bring your laptop charger.",
      "AI Usage: The use of artificial intelligence tools is prohibited."
    ],
    venue: "A12, LICET",
    teamSize: "3",
    time: "12:30pm - 2:30pm",
    formfields: [
      { id: 'phoneNumber', label: 'Phone Number', placeholder: 'Phone Number without country code', type: 'text' },
      { id: 'leaderName', label: 'Leader Name', placeholder: 'Leader Name', type: 'text' },
      { id: 'memberName1', label: 'First Member\' Name', placeholder: 'First Member\' Name', type: 'text' },
      { id: 'memberName2', label: 'Second Member\' Name', placeholder: 'Second Member\' Name', type: 'text' },
      { id: 'teamName', label: 'Team Name', placeholder: 'Hello World', type: 'text' },
      { id: 'collegeName', label: 'College Name', placeholder: 'LICET', type: 'text' }
    ],
    imageSrc:"https://i.ibb.co/8581p4R/Capturethe-Throne-removebg-preview.png",
    navigation:"/Capture-the-Throne/register",
    poster:captureTheThrone
  },
    {
      path: "/Scrolls-of-the-Seven-Kingdoms",
      name: "Scrolls of the Seven Kingdoms",
      sh_desc:"Paper Presentation",
      description: "Step into the future with our event! This is your chance to present game-changing ideas and discoveries in the ever-evolving world of computer science. Whether you're a coding wizard, a data science guru, or a tech visionary, this platform is designed to spotlight groundbreaking innovations that push the boundaries of technology. Join us and showcase your bold research, revolutionary solutions, and visionary concepts that will shape tomorrow's tech landscape. Standout teams with impressive presentations will be awarded exclusive prizes!",
      rules: [
        "Team size: 1-2 members per team ",
        "The time given per presentation is 10 mins including Q&A",
        "All content including images and code should be original. Plagiarism will lead to disqualification",
        "The team leader will get an email if you are shortlisted (based on the document and PPT you submit)"
      ],
      venue: "I21",
      teamSize: "1-2",
      time: "9am – 12pm",
      imageSrc:"https://i.ibb.co/gFNLJVC/Scrolls-of-the-Seven-Kingdoms-removebg-preview.png",
      poster:scrollsOfSevenKingdoms
    },
    {
      path: "/Quest-Beyond-the-Wall",
      name: "Quest Beyond the Wall",
      sh_desc:"Embark on a 2-hour treasure hunt where every minute counts!",
      description: "Embark on an exhilarating 2-hour treasure hunt where every minute counts! Teams will race across campus, tackling a variety of unique and challenging clues that will test their creativity, teamwork, and problem-solving skills. The hunt is packed with surprises, and only the quickest and cleverest teams will reach the final destination. Gather your team, get ready to explore, and see if you can outsmart the competition and claim the treasure!",
      rules: [
        "Team Composition: Each team must consist of 3 to 4 members.",
        "Duration: The event will last for 2 hours.",
        "Equipment: Teams should bring smartphones or tablets.",
        "Identification: Participants must carry their student ID cards.",
        "Team Identification: Each team will have a unique identifying id that must be displayed prominently.",
        "Phone Usage: Phones are allowed for checking clues. External help from search engines or forums is not allowed.",
        "Collaboration: Teams must work independently. Sharing clues or answers with other teams is prohibited.",
        "Round Time Limits: Each round must be completed within the specified time limit (e.g., 10-12 minutes). Teams that do not finish within the time limit will incur a time penalty or receive hints with a point deduction."
      ],
      venue: "I22,LICET",
      teamSize: "3-4",
      time: "9:30am - 11:30pm",
      imageSrc:"https://i.ibb.co/KXxgwzW/Quest-Beyond-the-Wall-removebg-preview.png",
      poster:questBeyondWall
    },
    {
      path: "/The-Iron-Code-Relay",
      name: "The Iron Code Relay",
      sh_desc:"Team-based coding competition to solve coding challenges.",
      description: "Code Relay challenges teams of four members to work together in solving coding problems. Each participant has exactly 5 minutes to code before passing the challenge to the next team member. The competition progresses through rounds of increasing difficulty, starting with simpler tasks and advancing to more complex algorithms. Teams compete on accuracy, code quality, and completion time. The event is hosted on the HackerRank platform, ensuring a fair environment for all participants.",
      rules: [
        "Team Composition: Each team must consist of exactly 4 members.",
        "Coding Time: Each participant codes for 5 minutes per turn.",
        "Switching Rule: Participants cannot assist each other but can strategize between turns.",
        "Absent Team Member: Teams with only 3 members wait 5 minutes before the next member can start.",
        "Challenge Setup: All teams receive the same coding problem, structured progressively in difficulty.",
        "Judging Criteria: Accuracy, code quality, and completion time determine the winner.",
        "Tools: Coding strictly on HackerRank; no external resources allowed.",
        "Disqualification: Breaking rules results in immediate disqualification."
      ],
      venue: "A12",
      teamSize: "4",
      imageSrc:"https://i.ibb.co/541DJ55/The-Iron-Code-Relay-removebg-preview.png",
      time: "10:00am - 12:00pm",
      poster:ironCodeRelay
    },
    {
      path: "/Defenders-Pitch",
      name: "Defenders Pitch",
      sh_desc:"Brainstorm, create, and defend! Teams develop innovative solutions and face the judges",
      description: "Defender's Pitch is a problem-solving competition where teams of 2-4 members are tasked with developing innovative solutions to real-world challenges. Beyond ideation, teams must validate their concepts and confidently defend their ideas against critical questioning, showcasing their creativity, research skills, and strategic thinking.",
      rules: [
        "Each team can consist of 2-4 members.",
        "Participants must bring their own laptops, chargers, and WiFi hotspots as backup.",
        "Participants must carry their college ID cards.",
        "The judges decision will be final.",
      ],
      venue: "I23",
      teamSize: "2-4",
      imageSrc:"https://i.ibb.co/BrWkfKx/Defenders-Pitch-removebg-preview.png",
      time: "10:30am - 12:30pm",
      poster:defendersPitch
    },
    {
      path: "/Drogons-Hackfest",
      name: "Drogons Hackfest",
      sh_desc:"Thrilling 2-day hackathon",
      description: "Dragons Hackfest is a thrilling 2-day hackathon where the teams will be given the problem statement two days before the event, providing them the opportunity to ideate, collaborate, and build their solutions.            The event encourages inter-departmental participation, fostering a collaborative spirit across various disciplines. Participants are required to bring their own laptops for presentations.",
      rules: [
        "The judges' decision will be deemed final.",
        "Teams must complete their projects by the specified deadline.",
        "The participants should bring their own laptops for the presentation.",
        "Presentations should last approximately 5-7 minutes."
      ],
      venue: "COE LAB(I11)",
      teamSize: "2-4",
      imageSrc:"https://i.ibb.co/JchJLRc/Drogons-Hackfest-removebg-preview.png",
      time: "9:00am - 2:30pm",
      poster:drogonsHackfest
    },
    {
      path: "/The-Kings-Design",
      name: "The King's Design",
      sh_desc:"A Game of Thrones UI/UX Event",
      description: "The King’s Design is a UI/UX event that challenges designers to prove their worth. You will face a monumental challenge in creating innovative solutions for a real-world problem. In Round 1, participants will focus on designing high-fidelity UIs based on provided assets and prompts. The top 15 teams will then advance to Round 2, where they’ll tackle a more conceptual UX challenge, creating wireframes and user flows for a specified app or website scenario. The emphasis in Round 2 is on creating smooth, intuitive user experiences.",
      rules: [
        "Team Composition: Teams can consist of either individual participants or a team of 2 members.",
        "Duration: The competition is for 2.5 hours.",
        "Equipment: if you are using figma systems will be provided ,if you are using adobe xd bring your own laptop",
        "Identification: Participants must bring their college ID cards.",
        "Development Tools: Ony Figma or Adobe XD are allowed.",
        "Assets Provided: Design assets, including a UI kit and icons, will be provided at the start of the event.",
        "AI Usage: AI tools are prohibited during the competition.",
        "All designs must be created during the event.",
        "Any breach of the rules will result in disqualification."
      ],
      venue: "I22",
      teamSize: "1-2",
      imageSrc:"https://i.ibb.co/BzS0wLr/The-King-s-Design-removebg-preview.png",
      time: "12:30 - 2:30pm",
      poster:kingsDesign
    },
    {
      path: "/The-War-for-Westeros",
      name: "The War for Westeros",
      sh_desc:"A premier head-to-head coding challenge",      
      description: "A premier head-to-head coding challenge designed to push your technical abilities to the limit. This competition is crafted for students and aspiring developers offering a dynamic platform to demonstrate your expertise in data structures, algorithms, and complex problem-solving. Participants will engage in a series of progressively challenging rounds, each designed to assess core skills such as algorithm optimization, data manipulation, and computational efficiency. This is not just a test of speed, but of strategic thinking, precision, and the ability to implement innovative solutions under pressure. In this rigorous competition you need to prove that you have what it takes to solve the most demanding technical challenges.  ",
      rules: [
        "Each participant enters the battle alone.",
        "The competition lasts for 1.5 - 2 hours.",
        "No personal gadgets are required. Computers will be provided for coding.",
        "Participants must bring their ID cards.",
        "Participants may choose to wield C, Java or Python as their weapon of choice in battle.",
        "Punctuality is key—no latecomers will be permitted to join the war.",
        "Any breach of the rules or dishonorable conduct will result in immediate disqualification."
      ],
      venue: "H22",
      teamSize: "1",
      imageSrc:"https://i.ibb.co/7jftdvf/The-War-of-Westros-removebg-preview.png", 
      time: "9:30am - 11:30am",
      poster:warOfWestros
    },
    {
      path: "/workshop",
      name: "Software Testing and Automation",
      sh_desc:"Workshop",
      description: "Master cutting-edge technologies such as Selenium, TestNG to automate testing processes. The workshop will include engaging hands-on activities and insightful discussions, providing a valuable chance to enhance your technical skills.",
      rules: [
        "⁠Only Engineering Students are allowed.",
        " ⁠Participants must bring their ID cards; those without ID will not be permitted.",
      ],
      venue: "A11",
      teamSize: "1",
      time: "9.30AM - 3.00PM",
      imageSrc:workshopImage,
      poster:workShopPoster
    },

  ];
  